<template>
    <section class="innerpages animate__animated animate__slideInRight">
      <div class="container ">
        <div class="row">
          <div class="col-md-12 listPage">
            <h1 class="text-truncate" :title="activeItem.label">{{activeItem.label}}</h1>
            <div class="card ">
              <b-table
                :items="nonZeroData"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                sort-icon-right
                responsive="sm"
                show-empty
                @row-clicked="openList"
                tbody-tr-class="dataDivider"
                class="fixed-width-table"
                >
                <template v-slot:empty="scope">
                  <h5 class="noData">No Data</h5>
                </template>
                <template v-slot:cell(count)="data">
                  <i 
                    style="font-style: normal; cursor: pointer;"
                    :style="data.item.is_less === true ? { color: 'red' } : data.item.is_less === false ? { color: 'green' } : {}"
                    @click.stop="handleCountClick(data.item, $event)"
                  >
                    {{ data.value }}
                    <span v-if="!data.item.is_amount" class="icon-arrow">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                        viewBox="0 0 407.436 407.436" xml:space="preserve">
                        <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718"></polygon>
                      </svg>
                    </span>
                  </i>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <b-modal
        hide-footer
        centered
        size="sm"
        v-model="showModal" title="Details">
        <div>
          <strong>Date:</strong> {{ dateFrom }} to {{ dateTo }}
        </div>
        <hr>
        <div v-if="selectedItem">
          <b-row>
            <b-col><strong>Actual:</strong> {{ selectedItem.data.actual }}</b-col>
            <b-col><strong>Targeted:</strong> {{ selectedItem.data.targeted }}</b-col>
          </b-row>
        </div>
      </b-modal>
      </div>
    </section>
  </template>
  <script>
  export default {
     data(){
      return {
        sortBy: 'count',
        sortDesc: false,
        showModal: false,
        selectedItem: null,
        dateFrom: this.$route.query.start_date,
        dateTo: this.$route.query.end_date,
      }
    },
    methods: {
      handleCountClick(item, event) {
        if (item.is_less === true || item.is_less === false) {
          this.selectedItem = item;
          this.showModal = true;
        } else {
          this.openList(item, null, event);
        }
      },
      openList(item, index, event){
        if (event?.target?.closest('i') && item.is_less !== undefined) return;
        if (!item.is_amount) {
          this.$router.push({
            path: `/leads/for/${this.activeItem.itemType}/${this.activeItem.itemId}`,
            query: {
              ...this.$route.query,
              lead_type: item.lead_type
            }
          });
        }
      }
    },
    computed: {
      activeItem(){
        return this.$store.getters.activeItem;
      },
      activeTitle(){
        return this.$store.getters.activeTitle;
      },
      nonZeroData() {
        return this.activeItem.data
      },
      fields() {
        return [
          {
            key: 'name',
            sortable: true,
            thStyle: { width: '60%' }
          },
          {
            key: 'count',
            sortable: true,
            thStyle: { width: '40%' }
          },
        ];
    },
      defaultDates(){
        return this.$store.getters.defaultDates;
      },
      fromDate(){
        return this.defaultDates.from;
      },
      toDate(){
        return this.defaultDates.upto;
      }
    }
  }
  </script>